import './MentFiltersStyle.css'
import Button from '../Button/Button'
import InputField from '../InputField/InputField'
import '../FilterPasscall/FilterPasscallStyle.css'
import { useState } from 'react'
import DropdropFilter from '../DropdropFilter/DropdropFilter'

function MentFilters({ isActive, setIsActive, setIsdropdown , interests, topics, selectedExperience, selectedTopic, selectedInterest, handleExperienceChange, handleTopicChange, handleInterestChange, handleFilterResult, handleDiscardFilters }) {

    const yrsOfExpOptions = [
        {
            label: "0-3 years",
            value: "3"
        },
        {
            label: "3-5 years",
            value: "5"
        },
        {
            label: "5-10 years",
            value: "10"
        },
        {
            label: "10+ years",
            value: "50"
        },
    ];

    return (

        <div className={`popupWrapper poupviewtab ${isActive && "active"}`}>
            <div className="popupContainer filterpoupmain">
                <div className="popupBody Adfilterpopup">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={() => setIsActive(false)} />
                    </span>
                    <div className="headingpoup"><h3>Filters</h3></div>
                    <div className="ContentBodyWrapperPastCall">
                        <DropdropFilter Dropname={"Expertise"} value={selectedInterest} options={interests} onClick={handleInterestChange} />
                        <DropdropFilter Dropname={"Topic"} value={selectedTopic} options={topics} onClick={handleTopicChange} />
                        <DropdropFilter Dropname={"Experience"} value={selectedExperience} options={yrsOfExpOptions} onClick={handleExperienceChange} />
                        <div className="FilterButtonPassCall w-100 flex-center gap-20 mt10">
                            <Button name={'Clear All'} className=" buttontext GreyFillButton w-100" onClick={handleDiscardFilters} />
                            <Button name={'Show Results'} className=" buttontext BlueFillButton w-100" onClick={handleFilterResult} />
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MentFilters